
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/dashboard/overview",
      function () {
        return require("private-next-pages/dashboard/overview.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/dashboard/overview"])
      });
    }
  